module.exports = __webpack_public_path__ + "img/taib4.23bc7a50.png";